import { useToast, useValidatorSeeker } from "@hooks"
import { acrissGroupBy, directSiteBrokerProvider, reports, searchID } from "@signals"
import { batch } from "@preact/signals-react"
import { postSubmit } from "@ui-seeker/utils"
import { useCallback } from "react"

import { analyzerFilters } from "Pages/AnalyzersV2/@signals"
import { isOneWayLoading, oneWayData, oneWayExcelPayload, oneWayPayload } from "Pages/AnalyzersV2/OneWay/@signals"
import { oneWaySchema } from "Pages/AnalyzersV2/OneWay/schema"


export default function useAnalyzerOneWayFilters() {
	const { showToast } = useToast()

	const { isValid, errorRegistry } = useValidatorSeeker(
		oneWayPayload.value,
		oneWaySchema(searchID.value, !!directSiteBrokerProvider.value, acrissGroupBy.value)
	)

	const onSubmit = useCallback(() => batch(() => {
		isOneWayLoading.value = true
		oneWayData.value = {}

		postSubmit("/api/dashboard/results", oneWayPayload.value).then(res => {
			oneWayData.value = res
			oneWayExcelPayload.value = oneWayPayload.value
			isOneWayLoading.value = false
			analyzerFilters.value = res.filters
		}).catch(() => {
			showToast.error()
			isOneWayLoading.value = false
		})
	}), [])

	return {
		onSubmit: onSubmit,
		// Unlike the other analyzers, a search does NOT bypass the schema: branch, currency
		// and the chosen group by dimension are mandatory however the page was reached.
		// `officePickupID` is the only field the schema already drops when there is a search.
		isValid: isValid && (!!reports.value || !!searchID.value),
		errorRegistry: errorRegistry
	}
}